(function () {
  var mainBtn = null;
  var stickyBar = null;
  var waBtn = null;
  var sectionId = null;
var STICKY_LABEL ='Agregar al carrito';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); }
  }

  function getStickyButton() {
    return stickyBar ? stickyBar.querySelector('.sticky-add-to-cart__button') : null;
  }

  function syncButtonState() {
    var stickyBtn = getStickyButton();
    if (!mainBtn || !stickyBtn) { return; }
    stickyBtn.disabled = false;
  stickyBtn.setAttribute('aria-disabled', mainBtn.disabled ? 'true' : 'false');
    var mainLabel = mainBtn.querySelector('span');
    var stickyLabel = stickyBtn.querySelector('span');
if (mainBtn.disabled) { if (mainLabel && stickyLabel) { stickyLabel.textContent = mainLabel.textContent; } } else if (stickyLabel) { stickyLabel.textContent = STICKY_LABEL; }
  }

  function updateWhatsapp(visible) {
    if (!waBtn) { return; }
    if (!waBtn.dataset.stickyTransition) {
      waBtn.style.transition = waBtn.style.transition + ', bottom 0.3s ease';
      waBtn.dataset.stickyTransition = 'true';
    }
    if (visible && stickyBar) {
      var h = stickyBar.offsetHeight;
      waBtn.style.bottom = (h + 16) + 'px';
    } else {
      waBtn.style.bottom = '';
    }
  }

  function setVisible(visible) {
    if (!stickyBar) { return; }
    stickyBar.classList.toggle('is-visible', visible);
    updateWhatsapp(visible);
  }

  function onIntersect(entries) {
    var entry = entries[0];
    setVisible(!entry.isIntersecting);
  }

  function onStickyClick(e) {
    e.preventDefault();
    if (!mainBtn) { return; }
    if (mainBtn.disabled) {
      var scrollTarget = document.querySelector('variant-selects, variant-radios') || mainBtn;
      scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
      scrollTarget.classList.add('sticky-add-to-cart__highlight');
      setTimeout(function () { scrollTarget.classList.remove('sticky-add-to-cart__highlight'); }, 1200);
      return;
    }
    var stickyBtn = e.currentTarget;
    if (stickyBtn.classList.contains('is-loading')) return;
    stickyBtn.classList.add('is-loading');
    setTimeout(clearStickyLoading, 3000);
    mainBtn.click();
  }

  function clearStickyLoading() {
    var b = document.querySelector('.sticky-add-to-cart__button');
    if (!b) return;
    if (!b.classList.contains('is-loading')) return;
    b.classList.remove('is-loading');
    b.classList.add('is-done');
    setTimeout(function () { b.classList.remove('is-done'); }, 1200);
  }

  function init() {
    stickyBar = document.querySelector('.sticky-add-to-cart');
    if (!stickyBar) { return; }
    sectionId = stickyBar.getAttribute('data-section-id');
    mainBtn = document.getElementById('ProductSubmitButton-' + sectionId);
    waBtn = document.getElementById('whatsapp-float-button');
    var stickyBtn = getStickyButton();

    if (mainBtn && stickyBtn) {
      syncButtonState();
      stickyBtn.addEventListener('click', onStickyClick);
      var mo = new MutationObserver(syncButtonState);
      mo.observe(mainBtn, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
      var vPicker = document.querySelector('variant-selects, variant-radios');
      if (vPicker) { vPicker.addEventListener('change', function () { setTimeout(syncButtonState, 60); }); }
    }

    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      var dmo = new MutationObserver(function () {
        if (drawer.classList.contains('active')) { clearStickyLoading(); }
      });
      dmo.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    if (mainBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(onIntersect, { root: null, threshold: 0 });
      io.observe(mainBtn);
    } else if (stickyBar) {
      stickyBar.classList.add('is-visible');
    }

    window.addEventListener('resize', function () {
      if (stickyBar && stickyBar.classList.contains('is-visible')) { updateWhatsapp(true); }
    });
  }

  ready(init);
})();
